import {CustomerContext, CustomerItem, UserContext} from "@apps/Shared/Context/CustomerContext";
import {CUSTOMER_STATE_CONTEXT, USER_STATE_CONTEXT} from "@frontendUtils/browser-storage";

export function GetCustomerSessionContext(): CustomerContext | null {
    let ctx: CustomerContext | null = null;
    try {
        const data = sessionStorage.getItem(CUSTOMER_STATE_CONTEXT);
        if (data) {
            ctx = JSON.parse(data);
        }
    } catch (e) {
        console.warn('[FG]::', e);
    }
    return ctx;
}

export function GetUserSessionContext(): UserContext | null {
    let ctx: UserContext | null = null;
    try {
        const data = sessionStorage.getItem(USER_STATE_CONTEXT);
        if (data) {
            ctx = JSON.parse(data);
        }
    } catch (e) {
        console.warn(e);
    }
    return ctx;
}

function FindCustomerById(customers: CustomerItem[] = [], customerId?: string): CustomerItem | null {
    if (!customerId) {
        return null;
    }

    for (const customer of customers) {
        if (customer.id === customerId) {
            return customer;
        }

        const connectedCustomer = FindCustomerById(customer.connectedCompanies ?? [], customerId);
        if (connectedCustomer) {
            return connectedCustomer;
        }
    }

    return null;
}

export function HydrateActiveCustomer<T extends Partial<CustomerItem>>(activeCustomer: T): T {
    const customerContext = GetCustomerSessionContext();
    const matchingCustomer = FindCustomerById(customerContext?.Customers ?? [], activeCustomer.id);

    if (!matchingCustomer) {
        return activeCustomer;
    }

    return {
        ...matchingCustomer,
        ...activeCustomer,
        features: activeCustomer.features?.length ? activeCustomer.features : matchingCustomer.features,
    };
}
